import Vue from 'vue'
import Router from 'vue-router'
import Profile from '@/components/views/Profile/Profile'
import ForgotPassword from '@/components/views/Profile/ForgotPassword'
import ResetPassword from '@/components/views/Profile/ResetPassword'
import Register from '@/components/views/Register/Register'
import RegisterConfirm from '@/components/views/Register/Confirm'
import RegisterSuccess from '@/components/views/Register/Success'
import Forbidden from '@/components/views/Shared/Forbidden'
import NotFound from '@/components/views/Shared/NotFound'
import Constants from '@/common/constants'
const Manager = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Manager.vue')
const Users = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Users/Users.vue')
const UserCreate = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Users/UserCreate.vue')
const UserInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Users/UserInfo.vue')
const Roles = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Roles/Roles.vue')
const RoleCreate = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Roles/RoleCreate.vue')
const RoleInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Roles/RoleInfo.vue')
const Layers = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Layers/Layers.vue')
const LayerInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Layers/LayerInfo.vue')
const References = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/References/References.vue')
const LayerReference = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/References/LayerReference.vue')
const LayerReferenceCreate = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/References/LayerReferenceCreate.vue')
const Workspaces = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Workspaces/Workspaces.vue')
const WorkspaceInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Workspaces/WorkspaceInfo.vue')
const WorkspaceCreate = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Workspaces/WorkspaceCreate.vue')
const Maps = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Maps/Maps.vue')
const MapInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Maps/MapInfo.vue')
const LayerGroups = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Layergroups/LayerGroups.vue')
const LayerGroupInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Layergroups/LayerGroupInfo.vue')
const FonMaps = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/FonMaps/FonMaps.vue')
const FonMapInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/FonMaps/FonMapInfo.vue')
const FonMapsSetting = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/FonMaps/FonMapsSetting.vue')
const DataStore = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/DataStore/DataStore.vue')
const DataStoreInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/DataStore/DataStoreInfo.vue')
const DataStoreCreate = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/DataStore/DataStoreCreate.vue')
const Topics = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Topics/Topics.vue')
const TopicInfo = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Topics/TopicInfo.vue')
const TopicsSetting = () => import(/* webpackChunkName: "manager" */ '@/components/views/Manager/Topics/TopicsSetting.vue')

Vue.use(Router)

const shouldDisableProfileRoutes = process.env.DISABLE_REGISTER_AND_PROFILE_ROUTES === 'true';

export default new Router({
	mode: 'history',
	routes: [
		{
			path: '/',
			name: 'home',
			meta: { title: '' },
			beforeEnter() { location.href = process.env.VIEWER_URL }
		},
		{
			path: '/403',
			name: '403',
			meta: { title: 'Доступ ограничен' },
			component: Forbidden
		},
    ...(!shouldDisableProfileRoutes ? [
      {
        path: '/profile/forgotpassword',
        name: 'profile_forgot_password',
        meta: { title: 'Забыли пароль' },
        component: ForgotPassword
      },
      {
        path: '/profile/resetpassword',
        name: 'profile_reset_password',
        meta: { title: 'Восстановление пароля' },
        component: ResetPassword,
        props: (route) => ({ uid: route.query.uid, token: route.query.token })
      },
      {
        path: '/profile',
        name: 'profile',
        meta: { title: 'Профиль' },
        component: Profile,
        meta: { isAuthenticated: true }
      },
      {
        path: '/register',
        name: 'register',
        meta: { title: 'Регистрация' },
        component: Register
      },
      {
        path: '/register/confirm',
        name: 'register_confirm',
        meta: { title: 'Подтверждение регистрации' },
        component: RegisterConfirm,
        props: (route) => ({ uid: route.query.uid, token: route.query.token })
      },
      {
        path: '/register/success',
        name: 'register_success',
        meta: { title: 'Регистрация завершена' },
        component: RegisterSuccess
      }
    ] : []),
		{
			path: '/manager',
			name: 'manager',
			component: Manager,
			meta: { isAuthenticated: true, access: "ROLE_MANAGER", title: 'Менеджер' },
			children: [
				{
					name: 'manager_users',
					path: 'users',
					meta: { title: 'Пользователи' },
					component: Users,
					children: [
						{
							name: 'user_create',
							path: 'create',
							meta: { title: 'Создание пользователя' },
							component: UserCreate
						},
						{
							name: 'user_info',
							path: '@:uid',
							meta: { title: 'Пользователи', titleKey:'uid' },
							component: UserInfo,
							props: (route) => ({ uid: route.params.uid })
						}
					]
				},
				{
					name: 'manager_roles',
					path: 'roles',
					meta: { title: 'Роли' },
					component: Roles,
					children: [
						{
							name: 'role_create',
							path: 'create',
							meta: { title: 'Создание роли' },
							component: RoleCreate
						},
						{
							name: 'role_info',
							path: '@:dn',
							meta: { title: 'Роли', titleKey:'dn' },
							component: RoleInfo,
							props: (route) => ({ dn: route.params.dn })
						}
					]
				},
				{
					name: 'manager_layers',
					path: 'layers',
					meta: { title: 'Слои' },
					component: Layers,
					children: [
						{
							name: 'layer_info',
							path: '@:name',
							meta: { title: 'Слои', titleKey:'name' },
							component: LayerInfo,
							props: (route) => ({ name: route.params.name })
						}
					]
				},
				{
					name: 'manager_references',
					path: 'references',
					meta: { title: 'Справочники' },
					component: References,
					children: [
						{
							name: 'reference_info',
							path: '@:name',
							meta: { title: 'Справочники', titleKey:'name' },
							component: LayerReference,
							props: (route) => ({ name: route.params.name })
						},
						{
							name: 'reference_create',
							path: 'create',
							meta: { title: 'Создание справочника' },
							component: LayerReferenceCreate
						}
					]
				},
				{
					name: 'manager_workspaces',
					path: 'workspaces',
					meta: { title: 'Рабочие области' },
					component: Workspaces,
					children: [
						{
							name: 'workspace_create',
							path: 'create',
							meta: { title: 'Создание рабочей области' },
							component: WorkspaceCreate
						},
						{
							name: 'workspace_info',
							path: '@:name',
							meta: { title: 'Рабочие области', titleKey:'name' },
							component: WorkspaceInfo,
							props: (route) => ({ name: route.params.name })
						}
					]
				},
				{
					name: 'manager_maps',
					path: 'maps',
					meta: { title: 'Карты' },
					component: Maps,
					children: [
						{
							name: 'map_create',
							path: 'create',
							meta: { title: 'Создание карты' },
							component: MapInfo,
							props: (route) => ({ id: Constants.NEW_ID })
						},
						{
							name: 'map_info',
							path: '@:id',
							meta: { title: 'Карты', titleKey:'id' },
							component: MapInfo,
							props: (route) => ({ id: route.params.id })
						}
					]
				},
				{
					name: 'manager_fonmaps',
					path: 'fonmaps',
					meta: { title: 'Подложки' },
					component: FonMaps,
					children: [
						{
							name: 'fon_map_info',
							path: '@:id',
							meta: { title: 'Подложки', titleKey:'id' },
							component: FonMapInfo,
							props: (route) => ({ id: route.params.id })
						},
						{
							name: 'fon_map_create',
							path: 'create',
							meta: { title: 'Создание подложки' },
							component: FonMapInfo,
							props: (route) => ({ id: Constants.NEW_ID })
						},
						{
							name: 'fon_map_setting',
							path: 'setting',
							meta: { title: 'Настройка порядка подложек на карте' },
							component: FonMapsSetting
						},
					]
				},
				{
					name: 'manager_datastores',
					path: 'storage',
					meta: { title: 'Хранилища' },
					component: DataStore,
					children: [
						{
							name: 'datastore_info',
							path: '@:datastore',
							meta: { title: 'Хранилища', titleKey:'id' },
							component: DataStoreInfo,
							props: (route) => ({ datastore: route.params.datastore})
						},
						{
							name: 'datastore_create',
							path: 'create',
							meta: { title: 'Подключение хранилища' },
							component: DataStoreCreate
						}
					]

				},
				{
					name: 'manager_layergroups',
					path: 'layergroups',
					meta: { title: 'Группы слоев' },
					component: LayerGroups,
					children: [
						{
							name: 'layergroup_info',
							path: '@:name',
							meta: { title: 'Информация о группе', titleKey:'name' },
							component: LayerGroupInfo,
							props: (route) => ({ name: route.params.name })
						}
					]
				},
				{
					name: 'manager_topics',
					path: 'topics',
					meta: { title: 'Тематические разделы' },
					component: Topics,
					children: [
						{
							name: 'topic_info',
							path: '@:id',
							meta: { title: 'Тематические разделы', titleKey:'id' },
							component: TopicInfo,
							props: (route) => ({ id: route.params.id })
						},
						{
							name: 'topic_create',
							path: 'create',
							meta: { title: 'Создание тематического раздела' },
							component: TopicInfo,
							props: (route) => ({ id: Constants.NEW_ID })
						},
						{
							name: 'topics_setting',
							path: 'setting',
							meta: { title: 'Настройка порядка тематических разделов' },
							component: TopicsSetting
						},
					]
				},
			]
		},
		{
			path: "*",
			name:'404',
			component: NotFound
		}
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js